import React, { Component } from 'react';
import {
  Collapse,
  Navbar,
  NavItem,
  NavLink,
  NavbarBrand,
  NavbarToggler,
  Nav,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';

import { FetchData } from './utils/DataFetch';
import { GetCookie, RemoveCookie } from './utils/Common';
import { UserChangePasswordForm } from './UserChangePasswordForm';

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor(props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true,
      appversion: '',
      passwordChangeModal: false,
    };
    this.user = JSON.parse(GetCookie('user'));

    this.handleLogout = this.handleLogout.bind(this);
    this.setPasswordChangeModal = this.setPasswordChangeModal.bind(this);
  }

  componentDidMount() {
    // get app version
    FetchData('/getappversion', 'POST', this.user.token, null).then((data) => {
      this.setState((prevState) => ({
        appversionBackend: data,
      }));
    });
  }

  toggleNavbar() {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  handleLogout() {
    // Get PUBLIC_URL from environment
    const redirectUrl = process.env.PUBLIC_URL || window.location.origin;

    fetch('/logout', {
      method: 'POST',
    })
      .then(() => {
        // Clear cookies and local storage
        RemoveCookie('user');
        localStorage.removeItem('RemoteTypes');
        localStorage.removeItem('RemoteHosts');
        localStorage.removeItem('JobTypes');
        localStorage.removeItem('JobInvLineCodes');

        // Redirect to PUBLIC_URL instead of reloading the page
        window.location.href = redirectUrl;
      })
      .catch((error) => {
        console.error('Logout failed:', error);
        // Still try to redirect even if logout API fails
        window.location.href = redirectUrl;
      });
  }

  setPasswordChangeModal = (value) => {
    if (this.state.passwordChangeModal !== value) {
      this.setState({ passwordChangeModal: value });
    }
  };

  render() {
    const appVersionFrontend = process.env.REACT_APP_VERSION ?? '0.0'
    var appversionBackend = this.state.appversionBackend;

    return (
      <header>
        <Navbar
          id={
            this.user.userrolename === 'Interpreter' || this.user.userrolename === 'Rep'
              ? 'navbarInterpreter'
              : 'navbarAdmin'
          }
          className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3"
          light
        >
          <NavbarBrand
            tag={Link}
            to="/"
            style={{
              color:
                // window.location.hostname.includes('stage.e-elainc.com') ||
                // window.location.hostname.includes('localhost')
                //   ? 'red'
                //   : 'black',

                'red',
            }}
          >
            Executive Linguist Agency. ver: {appVersionFrontend}-
            {appversionBackend}
          </NavbarBrand>
          <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
          {/* Removed duplicate nav links for mobile/desktop consistency */}
          <Collapse
            className="d-sm-inline-flex"
            isOpen={!this.state.collapsed}
            navbar
          >
            {this.user.userrolename === 'Rep' ? (
              <ul className="navbar-nav flex-grow-1">
                <NavItem>
                  <NavLink tag={Link} to="/rep-portal">
                    My Work Orders
                  </NavLink>
                </NavItem>
              </ul>
            ) : this.user.userrolename === 'Interpreter' ? (
              <ul className="navbar-nav flex-grow-1">
                <NavItem>
                  <NavLink tag={Link} to="/int-job">
                    Jobs and Payments
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} to="/check-in">
                    Share Your Schedule
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} to="/faq">
                    FAQ
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} to="/code-of-conduct">
                    Code of Conduct
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} to="/confidentiality-agreement">
                    Confidentiality Agreement
                  </NavLink>
                </NavItem>
              </ul>
            ) : (
              <ul className="navbar-nav flex-grow-1">
                {/* Empty nav list to maintain spacing for non-interpreter users */}
              </ul>
            )}
            <ul className="navbar-nav ms-auto">
              <UncontrolledDropdown
                inNavbar
                nav
                direction="down"
              >
                <DropdownToggle caret nav>
                  {this.user.firstname + ' ' + this.user.lastname}
                </DropdownToggle>
                <DropdownMenu
                  end
                  className="dropdown-menu-end"
                  style={{
                    position: 'absolute',
                    right: '0',
                    left: 'auto',
                    transform: 'none',
                  }}
                >
                  <DropdownItem>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={() => this.setPasswordChangeModal(true)}
                    >
                      Change Password
                    </a>
                  </DropdownItem>
                  <DropdownItem>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={this.handleLogout}
                    >
                      Logout
                    </a>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </ul>
          </Collapse>
        </Navbar>
        {this.state.passwordChangeModal && (
          <UserChangePasswordForm
            passwordChangeModal={this.state.passwordChangeModal}
            setPasswordChangeModal={this.setPasswordChangeModal}
            user={this.user}
          />
        )}
      </header>
    );
  }
}
